// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"3890a89f057d897d1f0b","655":"b590f7ff2c1fe33b40e2"}[chunkId] + ".js";
};